/**
 * Aloomah-Inspired Scroll Animations - Safe Version
 * Only animates elements that explicitly opt-in with classes
 */

(function() {
  'use strict';

  // Initialize
  function init() {
    // Only run if user hasn't disabled animations
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    setupScrollAnimations();
    setupSmoothScroll();
  }

  // Intersection Observer for scroll animations
  function setupScrollAnimations() {
    // Only observe elements that have opted-in to animations
    const animatedElements = document.querySelectorAll(
      '.aloomah-animate, .aloomah-fade-left, .aloomah-fade-right'
    );

    if (animatedElements.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          // Unobserve after animation for performance
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    animatedElements.forEach(el => observer.observe(el));
  }

  // Smooth scroll for anchor links
  function setupSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        if (href === '#' || href === '#!') return;

        const target = document.querySelector(href);
        if (!target) return;

        e.preventDefault();
        const offsetTop = target.offsetTop - 100;
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      });
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on AJAX navigation
  document.addEventListener('shopify:section:load', init);

})();
